import React from 'react';
import { TrendingUp } from 'lucide-react';
import DimensionTaskView from './DimensionTaskView';

const PersonalGrowth = ({ user }) => {
  return (
    <DimensionTaskView
      user={user}
      dimension="personal_growth"
      title="Personal Growth"
      icon={TrendingUp}
      color="#9C27B0"
    />
  );
};

export default PersonalGrowth;
